import React, { FC } from 'react';
import { Menu, Icon, IconSize, MenuItem, MenuOptions, Box, Text } from '@bechtel/gds';
import { PermissionMenuProps } from './types';
import { SelectedItemStyled, SelectBoxStyled } from './styled';
import { columnWidth } from '../matrix/styled';

const PermissionMenu: FC<PermissionMenuProps> = ({ applicableScopes, selectedScope, onScopeSelect, tabIndex }) => {
  return (
    <Menu>
      {({ placement, isOpen, toggle, close, referenceRef, popperRef }) => (
        <div
          style={{ flexGrow: 1 }}
          tabIndex={tabIndex}
          onBlur={() => {
            close();
          }}
        >
          {/* Added tabindex to make the div focussable so that menu can be closed by clicking outside */}
          <SelectBoxStyled ref={referenceRef}>
            <SelectedItemStyled onClick={toggle} selectedScope={selectedScope}>
              <Box mr={{ sm: '400' }}>
                <Text size="200" color="grey.1000" family="graphik">
                  {selectedScope.name}
                </Text>
              </Box>
              <Icon fillColor="bechtel.blue.800" icon={isOpen ? 'chevron-up' : 'chevron-down'} size={IconSize.MEDIUM} />
            </SelectedItemStyled>
          </SelectBoxStyled>
          <div ref={popperRef} data-placement={placement} style={{ zIndex: 1 }}>
            {isOpen && applicableScopes && applicableScopes.length > 0 && (
              <MenuOptions>
                {applicableScopes.map((scopeItem) => (
                  <MenuItem
                    style={{ width: columnWidth }}
                    key={scopeItem.id}
                    onClick={(event) => {
                      onScopeSelect(scopeItem);
                      close();
                      event.preventDefault();
                    }}
                  >
                    {scopeItem.name}
                  </MenuItem>
                ))}
              </MenuOptions>
            )}
          </div>
        </div>
      )}
    </Menu>
  );
};

export default PermissionMenu;
